
import { useNavigate } from 'react-router-dom';

export default function CalendarBookingSection() {
  const navigate = useNavigate();

  const handleDoneWithYouBooking = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate('/consulting');
  };

  const handleCourseBooking = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate('/purchase');
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Choose Your Consultation Package
          </h2>
          <p className="text-xl text-gray-600 mb-12">
            Professional guidance to get your Georgia dealer license with confidence
          </p>

          <div className="grid md:grid-cols-2 gap-8">
            {/* Course Only */}
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Complete Course</h3>
              <div className="mb-2">
                <span className="text-lg line-through opacity-60">$197</span>
                <span className="text-4xl font-bold text-gray-900 ml-2">$97</span>
              </div>
              <p className="text-gray-600 mb-6">Self-paced learning with expert content</p>
              
              <ul className="space-y-3 mb-8 text-left">
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-green-500"></i>
                  <span className="text-gray-700">Complete 10-module course</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-green-500"></i>
                  <span className="text-gray-700">All templates & resources</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-green-500"></i>
                  <span className="text-gray-700">Completion certificate</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-green-500"></i>
                  <span className="text-gray-700">Lifetime access</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-green-500"></i>
                  <span className="text-gray-700">Email support</span>
                </li>
              </ul>
              
              <button 
                onClick={handleCourseBooking}
                className="w-full bg-gray-900 text-white py-3 rounded-full font-semibold hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                Get Course - $97
              </button>
            </div>

            {/* One-on-One Consulting Call */}
            <div className="bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-2xl p-8 shadow-lg text-black relative">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-black text-white px-4 py-2 rounded-full text-sm font-bold">MOST POPULAR</span>
              </div>
              
              <h3 className="text-2xl font-bold mb-4">One-on-One Consulting Call</h3>
              <div className="mb-2">
                <span className="text-lg line-through opacity-60">$997</span>
                <span className="text-4xl font-bold ml-2">$497</span>
              </div>
              <p className="mb-6 opacity-80">Complete hand-holding through your licensing journey</p>
              
              <ul className="space-y-3 mb-8 text-left">
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line"></i>
                  <span>3 one-hour consultation sessions</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line"></i>
                  <span>Application preparation assistance</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line"></i>
                  <span>Document review & feedback</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line"></i>
                  <span>Location scouting guidance</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line"></i>
                  <span>Complete 10-module course included</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line"></i>
                  <span>Priority email & phone support</span>
                </li>
              </ul>
              
              <button 
                onClick={handleDoneWithYouBooking}
                className="w-full bg-black text-white py-3 rounded-full font-semibold hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                Book Consultation - $497
              </button>
            </div>
          </div>

          {/* Additional CTA */}
          <div className="mt-12 text-center">
            <p className="text-gray-600 mb-4">
              <i className="ri-shield-check-line text-green-500 mr-2"></i>
              30-day money-back guarantee • Secure payment • 95% success rate
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
